
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import ChallengerDetailPartner from '@/components/Challenges/tabs/partners/ChallengerDetailPartner.vue';
  import {challengeModule, partnersModule, partnersState} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';
  import {PartnerModel} from '@/models/partner.model';

  @Component({
    components: {
      ChallengerDetailPartner
    }
  })
  export default class ChallengerDetailPartners extends Vue {

    @partnersModule.Getter('partners') partners!: PartnerModel[];
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel | null;

    async mounted() {
      if (this.challenge?.id) {
        await partnersState.fetchAll(this.challenge.id);
      }
    }
  }
